import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MyProfileService } from 'src/app/modules/dashboard/dash-info-cards/service/my-profile.service';

@Injectable({
  providedIn: 'root',
})
export class HrGuard implements CanActivate {
  constructor(
    private profileService: MyProfileService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.profileService.getDetails().pipe(
      map((data) => {
        if (data?.isHR) {
          return true;
        } else {
          this.router.navigate(['/main-dashboard']);
          return false;
        }
      })
    );
  }
}
